import styled from 'styled-components'
import Colors from '../../theme/colors'
import Fonts from '../../theme/fonts'
import ButtonComponent from '../../atoms/Button/Button'

export const Button = styled(ButtonComponent)`
  justify-content: center;
`

const Styles = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  * {
    font-family: ${Fonts.fontFamilies.Inter};
    font-style: normal;
    font-weight: normal;
    font-size: ${Fonts.fontSizes.p16};
    user-select: none;
  }

  .header {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 90%;
    h2, h3 {
      text-align: center;
      font-family: ${Fonts.fontFamilies.Montserrat};
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
    }

    h3 {
      color: ${Colors.Primary.GreyTextLight};
      font-weight: 500;
      font-size: 18px;
      line-height: 24px;
      margin: auto 0;
    }
  }

  footer {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    flex-order: bottom;
    ${Button}:last-child {
      margin-left: auto;
    }
  }
`

export default Styles
